import { error } from "toastr";
import {
  STAFF_GET_EVENTS,
  STAFF_GET_EVENTS_FAIL,
  STAFF_GET_EVENTS_SUCCESS,
  STAFF_PART_DETAILS,
  STAFF_PART_DETAILS_SUCCESS,
  STAFF_PART_DETAILS_FAIL,
  SERVICE_PROGRESS_NOTE,
  SERVICE_PROGRESS_NOTE_SUCCESS,
  SERVICE_PROGRESS_NOTE_FAIL,
  SERVICE_ITEM_DETAILS,
  SERVICE_ITEM_DETAILS_SUCCESS,
  SERVICE_ITEM_DETAILS_FAIL,
  POST_CLOCK_IN_TIME,
  POST_CLOCK_IN_TIME_SUCCESS,
  POST_CLOCK_IN_TIME_FAIL,
  STAFF_TASK_ID,
  STAFF_TASK_ID_SUCCESS,
  STAFF_TASK_ID_FAIL,
  GET_NOTE_BY_ID,
  GET_NOTE_BY_ID_FAIL,
  GET_NOTE_BY_ID_SUCCESS,
  UPDATE_STAFF_PRO_NOTE,
  UPDATE_STAFF_PRO_NOTE_FAIL,
  UPDATE_STAFF_PRO_NOTE_SUCCESS,
  LOGOUT_STAFF,
  LOGOUT_STAFF_SUCCESS,
  LOGOUT_STAFF_FAIL,
  POST_TIMMINGS,
  POST_TIMMINGS_FAIL,
  POST_TIMMINGS_SUCCESS,
  STAFF_ACTION,
  STAFF_ACTION_FAIL,
  STAFF_ACTION_SUCCESS,
  SUBMIT_INICIDENT_REPORT,
  SUBMIT_INICIDENT_REPORT_FAIL,
  SUBMIT_INICIDENT_REPORT_SUCCESS,
  SET_TASK_TIMEOUT,
  SET_TASK_TIMEOUT_FAIL,
  SET_TASK_TIMEOUT_SUCCESS,
  SHOW_MODAL,
  HIDE_MODAL,
  SUBMITION_APPROVAL,
  SUBMITION_APPROVAL_FAIL,
  SUBMITION_APPROVAL_SUCCESS,
  NOTES_BY_ADMIN,
  NOTES_BY_ADMIN_FAIL,
  NOTES_BY_ADMIN_SUCCESS,
  GET_EMPLOYEE_PROFILE_DETAILS,
  GET_EMPLOYEE_PROFILE_DETAILS_FAIL,
  GET_EMPLOYEE_PROFILE_DETAILS_SUCCESS,
  SEND_ATTACHMENTS_BY_EMPLOYEE,
  SEND_ATTACHMENTS_BY_EMPLOYEE_FAIL,
  SEND_ATTACHMENTS_BY_EMPLOYEE_SUCCESS,
  UPLOAD_REQ_DOCS,
  UPLOAD_REQ_DOCS_SUCCESS,
  UPLOAD_REQ_DOCS_FAIL,
  UPLOAD_STAFF_CERTIFICATE_DOCS,
  UPLOAD_STAFF_CERTIFICATE_DOCS_SUCCESS,
  UPLOAD_STAFF_CERTIFICATE_DOCS_FAIL,
  GET_DOCUMENTS_STATUS_LIST,
  GET_DOCUMENTS_STATUS_LIST_SUCCESS,
  GET_DOCUMENTS_STATUS_LIST_FAIL,
  GET_TRAININGS_STAFF,
  GET_TRAININGS_STAFF_SUCCESS,
  GET_TRAININGS_STAFF_FAIL,
  GET_INICIDENT_FORM_QUESTIONS,
  GET_INICIDENT_FORM_QUESTIONS_SUCCESS,
  GET_INICIDENT_FORM_QUESTIONS_FAIL,
  SUBMIT_INCIDENT_FORM_EMPLOYEE,
  SUBMIT_INCIDENT_FORM_EMPLOYEE_SUCCESS,
  SUBMIT_INCIDENT_FORM_EMPLOYEE_FAIL,
  GET_POLICY_FOR_EMPLOYEE,
  GET_POLICY_FOR_EMPLOYEE_SUCCESS,
  GET_POLICY_FOR_EMPLOYEE_FAIL,
  CONFIRM_TRAINING_TERMS_FAIL,
  CONFIRM_TRAINING_TERMS_SUCCESS,
  CONFIRM_TRAINING_TERMS,
  HIT_DOWNLOAD_FAIL,
  HIT_DOWNLOAD_SUCCESS,
  HIT_DOWNLOAD,
  GET_MY_SHIFTS,
  GET_MY_SHIFTS_SUCCESS,
  GET_MY_SHIFTS_FAIL,
  EMP_GET_FOLDERS,
  EMP_GET_FOLDERS_SUCCESS,
  EMP_GET_FOLDERS_FAIL,
  EMP_ADD_FILE_TO_FOLDER,
  EMP_ADD_FILE_TO_FOLDER_SUCCESS,
  EMP_ADD_FILE_TO_FOLDER_FAIL,
  EMP_GET_FOLDER_FILES,
  EMP_GET_FOLDER_FILES_SUCCESS,
  EMP_GET_FOLDER_FILES_FAIL,
  START_EMP_SHIFT,
  START_EMP_SHIFT_SUCCESS,
  START_EMP_SHIFT_FAIL,
  END_EMP_SHIFT,
  END_EMP_SHIFT_SUCCESS,
  END_EMP_SHIFT_FAIL,
  EMP_AVAILABILITY,
  EMP_AVAILABILITY_SUCCESS,
  EMP_AVAILABILITY_FAIL,
  EMP_ADD_AVAILABILITY,
  EMP_ADD_AVAILABILITY_SUCCESS,
  EMP_ADD_AVAILABILITY_FAIL,
  EMP_GET_OPEN_SHIFTS,
  EMP_GET_OPEN_SHIFTS_SUCCESS,
  EMP_GET_OPEN_SHIFTS_FAIL,
  REQUEST_OPEN_SHIFT,
  REQUEST_OPEN_SHIFT_SUCCESS,
  REQUEST_OPEN_SHIFT_FAIL,
  CANCEL_OPEN_SHIFT,
  CANCEL_OPEN_SHIFT_SUCCESS,
  CANCEL_OPEN_SHIFT_FAIL,
  GET_REQUESTED_OPEN_SHIFTS,
  GET_REQUESTED_OPEN_SHIFTS_SUCCESS,
  GET_REQUESTED_OPEN_SHIFTS_FAIL,
  USER_ACCOUNTS_LIST,
  USER_ACCOUNTS_LIST_SUCCESS,
  USER_ACCOUNTS_LIST_FAIL,
  SWITCH_ACCOUNT,
  SWITCH_ACCOUNT_SUCCESS,
  SWITCH_ACCOUNT_FAIL,
  REMOVE_EMP_SWITCH_ACCOUNT,
  REMOVE_EMP_SWITCH_ACCOUNT_SUCCESS,
  REMOVE_EMP_SWITCH_ACCOUNT_FAIL,
  GET_MEDICATION_DETAILS,
  GET_MEDICATION_DETAILS_SUCCESS,
  GET_MEDICATION_DETAILS_FAIL,
  SUBMIT_MED_REPORT,
  GET_EMP_MEDICINE_LIST,
  GET_EMP_MEDICINE_LIST_SUCCESS,
  GET_EMP_MEDICINE_LIST_FAIL,
  GET_TODAYS_MEDICATION,
  GET_TODAYS_MEDICATION_SUCCESS,
  GET_TODAYS_MEDICATION_FAIL,
  EMP_SUBMIT_MEDICATION,
  EMP_SUBMIT_MEDICATION_SUCCESS,
  EMP_SUBMIT_MEDICATION_FAIL,
  EMP_MEDICATION_PRN,
  EMP_MEDICATION_PRN_SUCCESS,
  EMP_MEDICATION_PRN_FAIL,
  SUBMIT_MED_REPORT_SUCCESS,
  SUBMIT_MED_REPORT_FAIL,
  SUBMIT_HAZARD_REPORT,
  SUBMIT_HAZARD_REPORT_SUCCESS,
  SUBMIT_HAZARD_REPORT_FAIL,
  SAVE_PROGRESS_NOTE,
  SAVE_PROGRESS_NOTE_SUCCESS,
  SAVE_PROGRESS_NOTE_FAIL,
  REFINE_TEXT,
  REFINE_TEXT_SUCCESS,
  REFINE_TEXT_FAIL,
  GET_SUPPORT_WORKER_TIME_SHEETS,
  GET_SUPPORT_WORKER_TIME_SHEETS_SUCCESS,
  GET_SUPPORT_WORKER_TIME_SHEETS_FAIL,
  SUBMIT_TIMESHEET_COMMENT,
  SUBMIT_TIMESHEET_COMMENT_SUCCESS,
  SUBMIT_TIMESHEET_COMMENT_FAIL,
  AWAY_PARTICIPANT,
  AWAY_PARTICIPANT_SUCCESS,
  AWAY_PARTICIPANT_ERROR,
  UPDATE_VEHICLE_DETAILS_EMPLOYEE,
  UPDATE_VEHICLE_DETAILS_EMPLOYEE_SUCCESS,
  UPDATE_VEHICLE_DETAILS_EMPLOYEE_FAIL,
  SUBMIT_EMPLOYEE_COMPLAINT_FORM,
  SUBMIT_EMPLOYEE_COMPLAINT_FORM_SUCCESS,
  SUBMIT_EMPLOYEE_COMPLAINT_FORM_FAIL,
  EMP_UPDATE_AVAILABILITY,
  EMP_UPDATE_AVAILABILITY_SUCCESS,
  EMP_UPDATE_AVAILABILITY_FAIL,
} from "./actionTypes";

export const updateVehicleDetails = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: UPDATE_VEHICLE_DETAILS_EMPLOYEE,
  payload: { data, onSuccess, onError },
});

export const updateVehicleDetailsSuccess = data => ({
  type: UPDATE_VEHICLE_DETAILS_EMPLOYEE_SUCCESS,
  payload: data,
});

export const updateVehicleDetailsFail = data => ({
  type: UPDATE_VEHICLE_DETAILS_EMPLOYEE_FAIL,
  payload: data,
});

export const submitTimeSheetComment = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: SUBMIT_TIMESHEET_COMMENT,
  payload: { data, onSuccess, onError },
});

export const submitTimeSheetCommentSuccess = data => ({
  type: SUBMIT_TIMESHEET_COMMENT_SUCCESS,
  payload: data,
});

export const submitTimeSheetCommentFail = data => ({
  type: SUBMIT_TIMESHEET_COMMENT_FAIL,
  payload: data,
});

export const getSupportWorkerTimeSheet = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_SUPPORT_WORKER_TIME_SHEETS,
  payload: { data, onSuccess, onError },
});

export const getSupportWorkerTimeSheetSuccess = data => ({
  type: GET_SUPPORT_WORKER_TIME_SHEETS_SUCCESS,
  payload: data,
});

export const getSupportWorkerTimeSheetFail = data => ({
  type: GET_SUPPORT_WORKER_TIME_SHEETS_FAIL,
  payload: data,
});

export const refineNotesText = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: REFINE_TEXT,
  payload: { data, onSuccess, onError },
});

export const refineNotesTextSuccess = data => ({
  type: REFINE_TEXT_SUCCESS,
  payload: data,
});

export const refineNotesTextFail = data => ({
  type: REFINE_TEXT_FAIL,
  payload: data,
});

export const submitHazardReport = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: SUBMIT_HAZARD_REPORT,
  payload: { data, onSuccess, onError },
});

export const submitHazardReportSuccess = data => ({
  type: SUBMIT_HAZARD_REPORT_SUCCESS,
  payload: data,
});

export const submitHazardReportFail = data => ({
  type: SUBMIT_HAZARD_REPORT_FAIL,
  payload: data,
});

export const saveProgressNoteByUser = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: SAVE_PROGRESS_NOTE,
  payload: { data, onSuccess, onError },
});

export const saveProgressNoteByUserSuccess = data => ({
  type: SAVE_PROGRESS_NOTE_SUCCESS,
  payload: data,
});

export const saveProgressNoteByUserFail = data => ({
  type: SAVE_PROGRESS_NOTE_FAIL,
  payload: data,
});

export const empMedicationPrn = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: EMP_MEDICATION_PRN,
  payload: { data, onSuccess, onError },
});

export const empMedicationPrnSuccess = data => ({
  type: EMP_MEDICATION_PRN_SUCCESS,
  payload: data,
});

export const empMedicationPrnFail = data => ({
  type: EMP_MEDICATION_PRN_FAIL,
  payload: data,
});

export const empSubmitMedication = (data = {}, onSuccess = () => {}, onError = () => {}, header = {}) => ({
  type: EMP_SUBMIT_MEDICATION,
  payload: { data, onSuccess, onError },
});

export const empSubmitMedicationSuccess = data => ({
  type: EMP_SUBMIT_MEDICATION_SUCCESS,
  payload: data,
});

export const empSubmitMedicationFail = data => ({
  type: EMP_SUBMIT_MEDICATION_FAIL,
  payload: data,
});

export const getTodaysMedications = (data = {}, onSuccess = () => {}, onError = () => {}, header = {}) => ({
  type: GET_TODAYS_MEDICATION,
  payload: { data, onSuccess, onError },
});

export const getTodaysMedicationsSuccess = data => ({
  type: GET_TODAYS_MEDICATION_SUCCESS,
  payload: data,
});

export const getTodaysMedicationsFail = data => ({
  type: GET_TODAYS_MEDICATION_FAIL,
  payload: data,
});

export const getEmpMedicines = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_EMP_MEDICINE_LIST,
  payload: { data, onSuccess, onError },
});

export const getEmpMedicinesSuccess = data => ({
  type: GET_EMP_MEDICINE_LIST_SUCCESS,
  payload: data,
});

export const getEmpMedicinesFail = data => ({
  type: GET_EMP_MEDICINE_LIST_FAIL,
  payload: data,
});

export const submitMedReport = (data = {}, onSuccess = () => {}, onError = () => {}, header = {}) => ({
  type: SUBMIT_MED_REPORT,
  payload: { data, onSuccess, onError, header },
});

export const submitMedReportSuccess = data => ({
  type: SUBMIT_MED_REPORT_SUCCESS,
  payload: data,
});

export const submitMedReportFail = data => ({
  type: SUBMIT_MED_REPORT_FAIL,
  payload: data,
});

export const getEmpMedicationDetails = (data = {}, onSuccess = () => {}, onError = () => {}, header = {}) => ({
  type: GET_MEDICATION_DETAILS,
  payload: { data, onSuccess, onError, header },
});

export const getEmpMedicationDetailsSuccess = data => ({
  type: GET_MEDICATION_DETAILS_SUCCESS,
  payload: data,
});

export const getEmpMedicationDetailsFail = data => ({
  type: GET_MEDICATION_DETAILS_FAIL,
  payload: data,
});

export const removeEmpSwitchAcc = (data = {}, onSuccess = () => {}, onError = () => {}, header = {}) => ({
  type: REMOVE_EMP_SWITCH_ACCOUNT,
  payload: { data, onSuccess, onError, header },
});

export const removeEmpSwitchAccSuccess = data => ({
  type: REMOVE_EMP_SWITCH_ACCOUNT_SUCCESS,
  payload: data,
});

export const removeEmpSwitchAccFail = data => ({
  type: REMOVE_EMP_SWITCH_ACCOUNT_FAIL,
  payload: data,
});

export const switchAccount = (data = {}, onSuccess = () => {}, onError = () => {}, header = {}) => ({
  type: SWITCH_ACCOUNT,
  payload: { data, onSuccess, onError, header },
});

export const switchAccountSuccess = data => ({
  type: SWITCH_ACCOUNT_SUCCESS,
  payload: data,
});

export const switchAccountFail = data => ({
  type: SWITCH_ACCOUNT_FAIL,
  payload: data,
});

export const accountsList = (data = {}, onSuccess = () => {}, onError = () => {}, header = {}) => ({
  type: USER_ACCOUNTS_LIST,
  payload: { data, onSuccess, onError, header },
});

export const accountsListSuccess = data => ({
  type: USER_ACCOUNTS_LIST_SUCCESS,
  payload: data,
});

export const accountsListFail = data => ({
  type: USER_ACCOUNTS_LIST_FAIL,
  payload: data,
});

export const getRequestedOpenShifts = data => ({
  type: GET_REQUESTED_OPEN_SHIFTS,
  payload: data,
});

export const getRequestedOpenShiftsSuccess = data => ({
  type: GET_REQUESTED_OPEN_SHIFTS_SUCCESS,
  payload: data,
});

export const getRequestedOpenShiftsFail = data => ({
  type: GET_REQUESTED_OPEN_SHIFTS_FAIL,
  payload: data,
});

export const cancelOpenShift = (data, dispatch) => ({
  type: CANCEL_OPEN_SHIFT,
  payload: { data, dispatch },
});

export const cancelOpenShiftSuccess = data => ({
  type: CANCEL_OPEN_SHIFT_SUCCESS,
  payload: data,
});

export const cancelOpenShiftFail = data => ({
  type: CANCEL_OPEN_SHIFT_FAIL,
  payload: data,
});

export const requestOpenShift = (data, dispatch) => ({
  type: REQUEST_OPEN_SHIFT,
  payload: { data, dispatch },
});

export const requestOpenShiftSuccess = data => ({
  type: REQUEST_OPEN_SHIFT_SUCCESS,
  payload: data,
});

export const requestOpenShiftFail = data => ({
  type: REQUEST_OPEN_SHIFT_FAIL,
  payload: data,
});

export const empGetOpenShift = data => ({
  type: EMP_GET_OPEN_SHIFTS,
  payload: data,
});

export const empGetOpenShiftSuccess = data => ({
  type: EMP_GET_OPEN_SHIFTS_SUCCESS,
  payload: data,
});

export const empGetOpenShiftFail = data => ({
  type: EMP_GET_OPEN_SHIFTS_FAIL,
  payload: data,
});

export const addEmpAvailability = data => ({
  type: EMP_ADD_AVAILABILITY,
  payload: data,
});

export const addEmpAvailabilitySuccess = data => ({
  type: EMP_ADD_AVAILABILITY_SUCCESS,
  payload: data,
});

export const addEmpAvailabilityFail = data => ({
  type: EMP_ADD_AVAILABILITY_FAIL,
  payload: data,
});

export const updateEmpAvailability = data => ({
  type: EMP_UPDATE_AVAILABILITY,
  payload: data,
});

export const updateEmpAvailabilitySuccess = data => ({
  type: EMP_UPDATE_AVAILABILITY_SUCCESS,
  payload: data,
});
export const updateEmpAvailabilityFail = data => ({
  type: EMP_UPDATE_AVAILABILITY_FAIL,
  payload: data,
});

export const getEmpAvailability = data => ({
  type: EMP_AVAILABILITY,
  payload: data,
});

export const getEmpAvailabilitySuccess = data => ({
  type: EMP_AVAILABILITY_SUCCESS,
  payload: data,
});

export const getEmpAvailabilityFail = data => ({
  type: EMP_AVAILABILITY_FAIL,
  payload: data,
});

export const endEmpShift = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: END_EMP_SHIFT,
  payload: { data, onSuccess, onError },
});

export const endEmpShiftSuccess = data => ({
  type: END_EMP_SHIFT_SUCCESS,
  payload: data,
});

export const endEmpShiftFail = data => ({
  type: END_EMP_SHIFT_FAIL,
  payload: data,
});

export const startEmpShift = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: START_EMP_SHIFT,
  payload: { data, onSuccess, onError },
});

export const startEmpShiftSuccess = data => ({
  type: START_EMP_SHIFT_SUCCESS,
  payload: data,
});

export const startEmpShiftFail = data => ({
  type: START_EMP_SHIFT_FAIL,
  payload: data,
});

export const empAddFileToFolder = (data, onSuccess = () => {}, onError = () => {}) => ({
  type: EMP_ADD_FILE_TO_FOLDER,
  payload: { data, onSuccess, onError },
});

export const empAddFileToFolderSuccess = data => ({
  type: EMP_ADD_FILE_TO_FOLDER_SUCCESS,
  payload: data,
});

export const empAddFileToFolderFail = data => ({
  type: EMP_ADD_FILE_TO_FOLDER_FAIL,
  payload: data,
});

export const empGetFoldersFile = data => ({
  type: EMP_GET_FOLDER_FILES,
  payload: data,
});

export const empGetFoldersFileSuccess = data => ({
  type: EMP_GET_FOLDER_FILES_SUCCESS,
  payload: data,
});

export const empGetFoldersFileFail = data => ({
  type: EMP_GET_FOLDER_FILES_FAIL,
  payload: data,
});

export const empGetFolders = data => ({
  type: EMP_GET_FOLDERS,
  payload: data,
});

export const empGetFoldersSuccess = data => ({
  type: EMP_GET_FOLDERS_SUCCESS,
  payload: data,
});

export const empGetFoldersFail = data => ({
  type: EMP_GET_FOLDERS_FAIL,
  payload: data,
});

export const hideModal = data => ({
  type: HIDE_MODAL,
  payload: data,
});

export const showModal = data => ({
  type: SHOW_MODAL,
  payload: data,
});

export const getMyShifts = data => ({
  type: GET_MY_SHIFTS,
  payload: data,
});

export const getMyShiftsSuccess = data => ({
  type: GET_MY_SHIFTS_SUCCESS,
  payload: data,
});

export const getMyShiftsFail = data => ({
  type: GET_MY_SHIFTS_FAIL,
  payload: data,
});

export const hitDownload = data => ({
  type: HIT_DOWNLOAD,
  payload: data,
});

export const hitDownloadSuccess = data => ({
  type: HIT_DOWNLOAD_SUCCESS,
  payload: data,
});

export const hitDownloadFail = data => ({
  type: HIT_DOWNLOAD_FAIL,
  payload: data,
});

export const confirmTrainingTerms = data => ({
  type: CONFIRM_TRAINING_TERMS,
  payload: data,
});

export const confirmTrainingTermsSuccess = data => ({
  type: CONFIRM_TRAINING_TERMS_SUCCESS,
  payload: data,
});

export const confirmTrainingTermsFail = data => ({
  type: CONFIRM_TRAINING_TERMS_FAIL,
  payload: data,
});

export const getPolicyForEmployee = data => ({
  type: GET_POLICY_FOR_EMPLOYEE,
  payload: data,
});
export const getPolicyForEmployeeSuccess = data => ({
  type: GET_POLICY_FOR_EMPLOYEE_SUCCESS,
  payload: data,
});
export const getPolicyForEmployeeFail = data => ({
  type: GET_POLICY_FOR_EMPLOYEE_FAIL,
  payload: data,
});

export const submitEmployeeIncidentForm = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: SUBMIT_INCIDENT_FORM_EMPLOYEE,
  payload: { data, onSuccess, onError },
});
export const submitEmployeeIncidentFormSuccess = data => ({
  type: SUBMIT_INCIDENT_FORM_EMPLOYEE_SUCCESS,
  payload: data,
});
export const submitEmployeeIncidentFormFail = data => ({
  type: SUBMIT_INCIDENT_FORM_EMPLOYEE_FAIL,
  payload: data,
});

export const getIncidentFormQuestion = data => ({
  type: GET_INICIDENT_FORM_QUESTIONS,
  payload: data,
});
export const getIncidentFormQuestionSuccess = data => ({
  type: GET_INICIDENT_FORM_QUESTIONS_SUCCESS,
  payload: data,
});
export const getIncidentFormQuestionFail = data => ({
  type: GET_INICIDENT_FORM_QUESTIONS_FAIL,
  payload: data,
});

export const getEmployeeTrainings = data => ({
  type: GET_TRAININGS_STAFF,
  payload: data,
});
export const getEmployeeTrainingsSuccess = data => ({
  type: GET_TRAININGS_STAFF_SUCCESS,
  payload: data,
});
export const getEmployeeTrainingsFail = data => ({
  type: GET_TRAININGS_STAFF_FAIL,
  payload: data,
});

export const documentsStatus = data => ({
  type: GET_DOCUMENTS_STATUS_LIST,
  payload: data,
});
export const documentsStatusSuccess = data => ({
  type: GET_DOCUMENTS_STATUS_LIST_SUCCESS,
  payload: data,
});
export const documentsStatusFail = data => ({
  type: GET_DOCUMENTS_STATUS_LIST_FAIL,
  payload: data,
});

export const uploadTrainingCertDocs = data => ({
  type: UPLOAD_STAFF_CERTIFICATE_DOCS,
  payload: data,
});
export const uploadTrainingCertDocsSuccess = data => ({
  type: UPLOAD_STAFF_CERTIFICATE_DOCS_SUCCESS,
  payload: data,
});
export const uploadTrainingCertDocsFail = data => ({
  type: UPLOAD_STAFF_CERTIFICATE_DOCS_FAIL,
  payload: data,
});

// not in use
export const uploadReqDocs = data => ({
  type: UPLOAD_REQ_DOCS,
  payload: data,
});
export const uploadReqDocsSuccess = data => ({
  type: UPLOAD_REQ_DOCS_SUCCESS,
  payload: data,
});
export const uploadReqDocsFail = data => ({
  type: UPLOAD_REQ_DOCS_FAIL,
  payload: data,
});

export const sendAttachmentsByEmployee = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: SEND_ATTACHMENTS_BY_EMPLOYEE,
  payload: { data, onSuccess, onError },
});
export const sendAttachmentsByEmployeeSuccess = data => ({
  type: SEND_ATTACHMENTS_BY_EMPLOYEE_SUCCESS,
  payload: data,
});
export const sendAttachmentsByEmployeeFail = data => ({
  type: SEND_ATTACHMENTS_BY_EMPLOYEE_FAIL,
  payload: data,
});

export const getEmployeeProfile = data => ({
  type: GET_EMPLOYEE_PROFILE_DETAILS,
  payload: { data },
});
export const getEmployeeProfileSuccess = data => ({
  type: GET_EMPLOYEE_PROFILE_DETAILS_SUCCESS,
  payload: data,
});
export const getEmployeeProfileFail = data => ({
  type: GET_EMPLOYEE_PROFILE_DETAILS_FAIL,
  payload: data,
});

export const notesByAdmin = (data, history, redirectUrl) => ({
  type: NOTES_BY_ADMIN,
  payload: { data, history, redirectUrl },
});

export const notesByAdminSuccess = data => ({
  type: NOTES_BY_ADMIN_SUCCESS,
  payload: data,
  history,
});

export const notesByAdminFail = data => ({
  type: NOTES_BY_ADMIN_FAIL,
  payload: data,
});

export const submitApprove = (data, history) => ({
  type: SUBMITION_APPROVAL,
  payload: { data, history },
});
export const submitApproveSuccess = data => ({
  type: SUBMITION_APPROVAL_SUCCESS,
  payload: data,
});
export const submitApproveFail = data => ({
  type: SUBMITION_APPROVAL_FAIL,
  payload: data,
});

export const setTaskTimeout = data => ({
  type: SET_TASK_TIMEOUT,
  payload: data,
});
export const setTaskTimeoutSuccess = data => ({
  type: SET_TASK_TIMEOUT_SUCCESS,
  payload: data,
});
export const setTaskTimeoutFail = data => ({
  type: SET_TASK_TIMEOUT_FAIL,
  payload: data,
});

export const submitIncidentReport = data => ({
  type: SUBMIT_INICIDENT_REPORT,
  payload: data,
});
export const submitIncidentReportSuccess = data => ({
  type: SUBMIT_INICIDENT_REPORT_SUCCESS,
  payload: data,
});
export const submitIncidentReportFail = data => ({
  type: SUBMIT_INICIDENT_REPORT_FAIL,
  payload: data,
});

export const staffAction = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: STAFF_ACTION,
  payload: { data, onError, onSuccess },
});
export const staffActionSuccess = data => ({
  type: STAFF_ACTION_SUCCESS,
  payload: data,
});
export const staffActionFail = data => ({
  type: STAFF_ACTION_FAIL,
  payload: data,
});

export const postTimmings = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: POST_TIMMINGS,
  payload: { data, onSuccess, onError },
});

export const postTimmingsSuccess = data => ({
  type: POST_TIMMINGS_SUCCESS,
  payload: data,
});

export const postTimmingsFail = data => ({
  type: POST_TIMMINGS_FAIL,
  payload: data,
});

export const logout_staff = data => ({
  type: LOGOUT_STAFF,
  payload: data,
});
export const logout_staffSuccess = data => ({
  type: LOGOUT_STAFF_SUCCESS,
  payload: data,
});
export const logout_staffFail = data => ({
  type: LOGOUT_STAFF_FAIL,
  payload: data,
});

export const updateStaffNote = data => ({
  type: UPDATE_STAFF_PRO_NOTE,
  payload: data,
});
export const updateStaffNoteSuccess = data => ({
  type: UPDATE_STAFF_PRO_NOTE_SUCCESS,
  payload: data,
});
export const updateStaffNoteFail = data => ({
  type: UPDATE_STAFF_PRO_NOTE_FAIL,
  payload: data,
});

export const getNoteById = data => ({
  type: GET_NOTE_BY_ID,
  payload: data,
});

export const getNoteByIdSuccess = events => ({
  type: GET_NOTE_BY_ID_SUCCESS,
  payload: events,
});

export const getNoteByIdFail = error => ({
  type: GET_NOTE_BY_ID_FAIL,
  payload: error,
});

export const staffTaskid = (data, onSuccess = () => {}, onError = () => {}) => ({
  type: STAFF_TASK_ID,
  payload: { data, onSuccess, onError },
});

export const staffTaskidSuccess = events => ({
  type: STAFF_TASK_ID_SUCCESS,
  payload: events,
});

export const staffTaskidFail = error => ({
  type: STAFF_TASK_ID_FAIL,
  payload: error,
});

export const staffgetEvents = data => ({
  type: STAFF_GET_EVENTS,
  payload: data,
});

export const staffgetEventsSuccess = events => ({
  type: STAFF_GET_EVENTS_SUCCESS,
  payload: events,
});

export const staffgetEventsFail = error => ({
  type: STAFF_GET_EVENTS_FAIL,
  payload: error,
});

export const getPartDetail = event => ({
  type: STAFF_PART_DETAILS,
  payload: event,
});

export const getPartDetailSuccess = event => ({
  type: STAFF_PART_DETAILS_SUCCESS,
  payload: event,
});

export const getPartDetailFail = error => ({
  type: STAFF_PART_DETAILS_FAIL,
  payload: error,
});

export const serviceProgressNote = event => ({
  type: SERVICE_PROGRESS_NOTE,
  payload: event,
});

export const serviceProgressNoteSuccess = event => ({
  type: SERVICE_PROGRESS_NOTE_SUCCESS,
  payload: event,
});

export const serviceProgressNoteFail = error => ({
  type: SERVICE_PROGRESS_NOTE_FAIL,
  payload: error,
});

export const getServiceItemDetails = event => ({
  type: SERVICE_ITEM_DETAILS,
  payload: event,
});

export const getServiceItemDetailsSuccess = event => ({
  type: SERVICE_ITEM_DETAILS_SUCCESS,
  payload: event,
});

export const getServiceItemDetailsFail = error => ({
  type: SERVICE_ITEM_DETAILS_FAIL,
  payload: error,
});

export const postClockInTime = data => ({
  type: POST_CLOCK_IN_TIME,
  payload: data,
});

export const postClockInTimeSuccess = data => ({
  type: POST_CLOCK_IN_TIME_SUCCESS,
  payload: data,
});

export const postClockInTimeFail = error => ({
  type: POST_CLOCK_IN_TIME_FAIL,
  payload: error,
});

export const awayPariticipant = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: AWAY_PARTICIPANT,
  payload: { data, onSuccess, onError },
});

export const awayPariticipantSuccess = data => ({
  type: AWAY_PARTICIPANT_SUCCESS,
  payload: data,
});

export const awayPariticipantError = error => ({
  type: AWAY_PARTICIPANT_ERROR,
  payload: error,
});

//GET_EMPLOYEE_SUBMITED_FORM

export const getEmployeeComplaintForm = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: SUBMIT_EMPLOYEE_COMPLAINT_FORM,
  payload: { data, onSuccess, onError },
});
export const getEmployeeComplaintFormSuccess = (data = {}) => ({
  type: SUBMIT_EMPLOYEE_COMPLAINT_FORM_SUCCESS,
  payload: data,
});
export const getEmployeeComplaintFormError = (data = {}) => ({
  type: SUBMIT_EMPLOYEE_COMPLAINT_FORM_FAIL,
  payload: data,
});
